import { useEffect } from 'react';
import Brand from '@/components/vitrine/Brand';
import '@/styles/construction-page.css';

const WHATSAPP_URL = 'https://wa.me/5562991827568?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20OperAIo.';

function WhatsAppIcon() {
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 3.6A11.8 11.8 0 0 0 12.1.1C5.6.1.3 5.4.3 11.9c0 2.1.6 4.2 1.6 6L.1 24l6.2-1.6a12 12 0 0 0 5.8 1.5h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.5Zm-8.3 18.3h-.1c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.7 1 1-3.6-.2-.4a9.8 9.8 0 1 1 8.5 4.6Zm5.4-7.3c-.3-.1-1.8-.9-2.1-1-.3-.1-.5-.1-.7.2l-1 1.2c-.2.2-.4.2-.7.1a8 8 0 0 1-2.4-1.5 9 9 0 0 1-1.6-2c-.2-.3 0-.5.1-.6l.5-.6.3-.5c.1-.2 0-.4 0-.6l-1-2.4c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9s1.2 3.3 1.4 3.6c.1.2 2.4 3.7 5.9 5.2.8.4 1.5.6 2 .7.8.3 1.6.2 2.2.1.7-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.4-.3-.7-.4Z" /></svg>;
}

export default function ConstructionPage() {
  useEffect(() => {
    document.title = 'OperAIo | Em construção';
  }, []);

  return (
    <main className="construction-page">
      <div className="construction-orbit construction-orbit-one" aria-hidden="true" />
      <div className="construction-orbit construction-orbit-two" aria-hidden="true" />
      <section className="construction-content" aria-labelledby="construction-title">
        <div className="construction-logo" aria-label="OperAIo"><Brand /></div>
        <div className="construction-rule" aria-hidden="true"><span /></div>
        <h1 id="construction-title">Em construção, voltamos em breve</h1>
        <a className="construction-contact" href={WHATSAPP_URL} target="_blank" rel="noreferrer" aria-label="Falar com a OperAIo pelo WhatsApp em uma nova aba">
          <WhatsAppIcon /><span>Fale com a gente pelo WhatsApp</span>
        </a>
      </section>
      <footer className="construction-footer">
        <span>© {new Date().getFullYear()} OperAIo</span>
        <span>Inteligência aplicada ao crescimento.</span>
      </footer>
    </main>
  );
}
